// Header avatar/name dropdown (My Account / Change My Password / Logout).
// Bound once via event delegation (not per Turbolinks visit), the same
// pattern as confirm_modal.js, since Turbolinks replaces the header on
// every visit.

function closeProfileMenu() {
  var trigger = document.getElementById('profile-menu-trigger')
  var dropdown = document.getElementById('profile-menu-dropdown')
  if (!trigger || !dropdown) return

  dropdown.hidden = true
  trigger.setAttribute('aria-expanded', 'false')
}

document.addEventListener('click', function (event) {
  var trigger = event.target.closest('#profile-menu-trigger')
  if (trigger) {
    var dropdown = document.getElementById('profile-menu-dropdown')
    if (!dropdown) return
    var willOpen = dropdown.hidden
    dropdown.hidden = !willOpen
    trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false')
    return
  }

  if (!event.target.closest('#profile-menu')) closeProfileMenu()
})

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') closeProfileMenu()
})
